import GetRequest from "../utilities/api/get-request";
import PostRequest from "../utilities/api/post-request";

class Setting {

    /*
    |--------------------------------------------------------------------------
    | Get order setting
    |--------------------------------------------------------------------------
    |
    */

    static async getOrder(filterParameters = {}) {
        const path = '/api/settings/order';

        return await GetRequest(path, filterParameters);
    }

    /*
    |--------------------------------------------------------------------------
    | Set Order Setting
    |--------------------------------------------------------------------------
    |
    */
    static async setOrder(data = {}) {
        const path = '/api/settings/order';

        return await PostRequest(path, data);
    }

    /*
    |--------------------------------------------------------------------------
    | Set currency settings
    |--------------------------------------------------------------------------
    |
    */
    static async setCurrencySettings(data = {}) {
        const path = '/api/settings/currency';

        return await PostRequest(path, data);
    }

}

export default Setting;